import {TrackingCoreComponentTypes} from '../../../types/tracking-core-events-type';

// Parameters accepted by the factory: all properties of a component event
// except the `event` field which will be set by the factory.
type TrackComponentParams = Omit<
  TrackingCoreComponentTypes,
  'event' | 'details' | 'abtest_flag' | 'event_scope' | 'object_details'
>;

type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

type TrackComponentParamsPartial = WithOptional<
  TrackComponentParams,
  'sponsored' | 'page_type_id'
>;

export type ShopFeatureEvent = {
  GA4: TrackingCoreComponentTypes;
};

export const trackComponent =
  (params: TrackComponentParamsPartial) => (): ShopFeatureEvent => {
    const event: ShopFeatureEvent = {
      GA4: {
        ...params,
        event: 'component',
        context: params.context ?? '',
        abtest_flag: false,
        event_scope: 'long',
        object_context: '',
        page_type_id: params.page_type_id ?? '',
      },
    };

    return event;
  };
